module.exports = __webpack_public_path__ + "img/ses_kayitlari.224524bd.jpg";